import CustomSkeleton from '@/components/Common/CustomSkeleton';

const ConfirmSectionLoading = () => <CustomSkeleton height={32} radius='xl' width='full' />;

export default ConfirmSectionLoading;
